// extracted by mini-css-extract-plugin
export default {"root":"CustomKeyword_root__Oo5qh","searchInput":"CustomKeyword_searchInput__xaHTF"};